













// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, computed } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartEvolutionContainer from '@/components/charts/ChartEvolutionContainer.vue';
// Import plugins ----------------------------------------------------------------------------------
import i18n from '@/plugins/i18n';
// Import utils - ----------------------------------------------------------------------------------
import { useChart, EThemeColor } from '@/utils/charts.utils';
import { EUnitKey } from '@/utils/parameter-units.utils';
import { useUnit } from '@/utils/unit.utils';
// Import types ------------------------------------------------------------------------------------
import type { TDataStandard } from '@/components/patient/PatientEvolution.vue';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ChartEvolutionCircumduction',
  components: {
    ChartEvolutionContainer
  },
  props: {
    manifest: {
      type: Array
    },
    circumduction: {
      type: Object
    },
    norms: {
      type: Object
    }
  },
  setup(properties) {
    const {
      evolutionChartStructure,
      getSideData,
      getSideDataVariations,
      getSerieItemStructure,
      getNormsStructure
    } = useChart();
    const { isImperial } = useUnit().currentUnit();

    const title = 'commons.standards.circumduction';

    const circumduction: TDataStandard = computed(() => getSideData(properties.circumduction));

    const dataVariations = computed(() =>
      getSideDataVariations({
        left: circumduction.value?.left.values,
        right: circumduction.value?.right.values
      })
    );

    const valid = computed(() => !!circumduction.value);

    const series = computed(() => {
      let data = [
        // Left
        getSerieItemStructure(
          'circumduction_left',
          `${i18n.t('commons.standards.circumduction')} (${(i18n.t('commons.standards.left') as string).slice(
            0,
            1
          )})`,
          circumduction.value?.left.values,
          EThemeColor.Chart1
        ),
        getSerieItemStructure(
          'circumduction_left',
          undefined,
          circumduction.value?.left.ranges,
          EThemeColor.Chart1,
          true
        ),
        // Right
        getSerieItemStructure(
          'circumduction_right',
          `${i18n.t('commons.standards.circumduction')} (${(
            i18n.t('commons.standards.right') as string
          ).slice(0, 1)})`,
          circumduction.value?.right.values,
          EThemeColor.Chart2
        ),
        getSerieItemStructure(
          'circumduction_right',
          undefined,
          circumduction.value?.right.ranges,
          EThemeColor.Chart2,
          true
        )
      ];
      // Have norms
      if (properties.norms)
        data.push(
          getNormsStructure('circumduction_norms', properties.norms as { min: number[]; max: number[] })
        );

      return data;
    });

    const chartOptions = computed(() => {
      return {
        ...evolutionChartStructure(
          title,
          properties.manifest,
          isImperial.value ? EUnitKey.Inch : EUnitKey.Centimeter,
          1
        ),
        series: series.value
      };
    });

    return {
      title,
      dataVariations,
      chartOptions,
      valid
    };
  }
});
